
import axios from "../javascript/custom-axios";
const API_URL = "/v1/elections";

export default {
  /**
   * @summary Eklenen seçimleri getir.
   * @route GET /elections
   * @param {Object} params
   * @param {string} params.page - Seçim başlığı
   * @param {string} params.pageSize - Seçim açıklaması
   * @returns {Promise}
   */
  getCommitteeElections(params) {
    return axios.get(`${API_URL}/get-elections`, { params });
  },

  /**
   * @summary Adayı sil.
   * @route GET /candidates/{candidateId}
   * @param {number} candidateId - Seçim açıklaması
   * @returns {Promise}
   */
  deleteCandidate(candidateId) {
    return axios.delete(`${API_URL}/candidates/${candidateId}`);
  },

  /**
   * @summary Yeni seçim oluşturur
   * @route POST /elections
   * @param {Object} data
   * @param {string} data.Title - Seçim başlığı
   * @param {string} data.Description - Seçim açıklaması
   * @returns {Promise}
   */
  createElection(data) {
    return axios.post(`${API_URL}`, data);
  },

  /**
   * @summary Seçimi durdurur
   * @route PUT /elections/{electionId}/stop
   * @param {number|string} electionId - Durdurulacak seçim ID'si
   * @returns {Promise}
   */
  stopElection(electionId) {
    return axios.put(`${API_URL}/${electionId}/stop`);
  },

  /**
   * @summary Seçime aday ekler
   * @route POST /elections/candidates
   * @param {Object} candidate
   * @param {number} candidate.ElectionId - Seçim ID'si
   * @param {string} candidate.Name - Aday adı
   * @param {string} candidate.Username - Aday kullanıcı adı
   * @param {string} candidate.Biography - Aday biyografisi
   * @param {number} candidate.PhotoFileId - Fotoğraf dosya ID'si
   * @param {string} candidate.Department - Bölüm
   * @param {string} candidate.Shift - Vardiya
   * @returns {Promise}
   */
  addCandidate(candidate) {
    return axios.post(`${API_URL}/candidates`, candidate);
  },

  /**
   * @summary Oy verme işlemi
   * @route POST /elections/{electionId}/votes/{candidateId}
   * @param {number|string} electionId - Seçim ID'si
   * @param {number|string} candidateId - Aday ID'si
   * @returns {Promise}
   */
  vote(electionId, candidateId) {
    return axios.post(`${API_URL}/${electionId}/votes/${candidateId}`);
  },

  /**
   * @summary Seçime ait adayları getirir
   * @route GET /elections/{electionId}/candidates
   * @param {number|string} electionId - Seçim ID'si
   * @returns {Promise}
   */
  getCandidates(electionId) {
    return axios.get(`${API_URL}/${electionId}/candidates`);
  },

  /**
   * @summary Seçim sonuçlarını getirir
   * @route GET /elections/{electionId}/results
   * @param {number|string} electionId - Seçim ID'si
   * @returns {Promise}
   */
  getResults(electionId) {
    return axios.get(`${API_URL}/${electionId}/results`);
  },

  /**
   * @summary Seçimi günceller.
   * @route PUT /elections/update-election
   * @param {Object} data
   * @param {number} data.Id - Seçim ID'si
   * @param {string} data.Title - Seçim başlığı
   * @param {string} data.Description - Seçim açıklaması
   * @param {boolean} data.IsActive - Aktiflik durumu
   * @param {string} data.Department - Bölüm
   * @param {string} data.Shift - Vardiya
   * @param {boolean} data.IsTest - Test seçimi mi
   * @returns {Promise}
   */
  updateElection(data) {
    return axios.put(`${API_URL}/update-election`, data);
  },

  /**
   * @summary Adayı günceller.
   * @route PUT /elections/update-candidate
   * @param {Object} data
   * @param {number} data.Id - Aday ID'si
   * @param {number} data.ElectionId - Seçim ID'si
   * @param {string} data.Name - Aday adı
   * @param {string} data.Username - Aday kullanıcı adı
   * @param {string} data.Biography - Aday biyografisi
   * @param {number} data.PhotoFileId - Fotoğraf dosya ID'si
   * @returns {Promise}
   */
  updateCandidate(data) {
    return axios.put(`${API_URL}/update-candidate`, data);
  },
};
